import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import {
    ApolloProvider,
    useQuery,
} from '@apollo/client';
import './_styles_/SecuredApp.css';
import MiddleContainer from './MiddleContainer';
import Notifications from './notifications/Notifications';
import createApolloClient from '../createApolloClient';
import useIdle from '../hooks/useIdle';
import { logoutUser } from '../actions/authentication';
import IdlePopup from './popups/IdlePopup';
import { getModalDialogs } from '../reducers';
import { loadPrivateConfig } from '../actions/configuration';
import useAuthentication from '../hooks/useAuthentication';
import GlobalMessages from './messages/GlobalMessages';
import useEffectOnLoad from '../hooks/useEffectOnLoad';
import { USER_CONFIGURATION } from '../graphql/userConfiguration';
import { showErrorNotification } from '../actions/notifications';
import { storeUserConfiguration } from '../actions/userConfiguration';

SecuredApp.propTypes = {
    timeToIdleInMins: PropTypes.number.isRequired,
    idlePopupOffsetInMins: PropTypes.number.isRequired,
};

function SecuredApp(props) {
    const {
        timeToIdleInMins,
        idlePopupOffsetInMins,
    } = props;
    const dispatch = useDispatch();
    const { t } = useTranslation();
    const { accessToken } = useAuthentication();
    const client = createApolloClient();
    const [isIdlePopupVisible, setIdlePopupVisible] = useState(false);
    const isModalDialogVisible = useSelector(getModalDialogs) > 0;
    const userActiveHandler = () => setIdlePopupVisible(false);
    useIdle(timeToIdleInMins - idlePopupOffsetInMins, () => setIdlePopupVisible(true), userActiveHandler);
    const onIdle = () => dispatch(logoutUser(t('logout.user-inactive', { mins: timeToIdleInMins }), client));
    useIdle(timeToIdleInMins, onIdle);
    useEffectOnLoad(() => {
        dispatch(loadPrivateConfig(accessToken));
    });
    useQuery(USER_CONFIGURATION, {
        client,
        onCompleted: (userConfigurationData) => dispatch(storeUserConfiguration(userConfigurationData.userConfiguration)),
        onError: () => dispatch(showErrorNotification(t('user-configuration.loading-failed'))),
    });
    return (
        <ApolloProvider client={client}>
            <GlobalMessages />
            <div className="secured-app">
                {!isModalDialogVisible && <Notifications />}
                <MiddleContainer />
                {isIdlePopupVisible && <IdlePopup onUserActive={userActiveHandler} popupOffsetInMins={idlePopupOffsetInMins} />}
            </div>
        </ApolloProvider>
    );
}

export default SecuredApp;
